import { z } from 'zod';

export type Weekday = z.infer<typeof weekdaySchema>;

export interface WeekdayOption {
	displayName: string;
	value: Weekday;
}

export const weekdaySchema = z.enum([
	'Sunday',
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
]);

export const weekdayOptionSchema = z.object({
	displayName: z.string(),
	value: weekdaySchema,
}) satisfies z.ZodType<WeekdayOption>;
